import dbImages from '../../config/databases/images';

export default async function deleteImages(formId = null) {
  let uploadedImages = [];
  if (formId === null) {
    uploadedImages = await dbImages.images.toArray();
  } else {
    uploadedImages = await dbImages.images
      .where('formId')
      .equals(formId.toString())
      .and((image) => image.status === 2)
      .toArray();
  }

  uploadedImages.map(async (image) => dbImages.images.delete(image.id));
}
